import { useTranslation } from 'react-i18next';
import { useGuides } from 'src/hook/components/useGuides';
import { ImageLocation } from 'src/utils/URLUtils';
import styles from './ContextLessonsFirstVisit.module.scss';

export default function ContextLessonsFirstVisit() {
    const { t } = useTranslation();
    const { hideGuide } = useGuides();
    return (
        <>
            <div className={`${styles.contextLessonsFirstVisit} guideModal`}>
                <img src={ImageLocation('Lexi/smile.png')} alt="lexi" className='lexiIcon' />
                <p className={styles.guideText}>{t('Learn how to ask questions, then answer them.')}</p>
            </div>

            <div className={styles.lessonQuestion}>
                <div className={styles.questionHeader}>
                    {t('Lesson')} 1/10
                </div>
                <div className={styles.questionContent}>
                    <h1>How are you?</h1>
                </div>
                <div className={styles.actionButtons}>
                    <button className={styles.skip} onClick={() => hideGuide()}>
                        {t('Skip')}
                    </button>
                    <button className={styles.next} onClick={() => hideGuide()}>
                        {t('Start')}
                    </button>
                </div>
            </div>
        </>
    );
} 